

    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import { Options, Vue  } from "vue-class-component";
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop   } from 'vue-property-decorator';
	import $ from "jquery"
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import DisciplinaEspacoLocavelService from   "@/service/v1/sigap/DisciplinaEspacoLocavelService";
    import EspacoService from   "@/service/v1/sigap/EspacoService";


    @Options({
        name: "DisciplinaEspacoCadastro",
        components: {   Multiselect, BotaoSalvar },
        emits: [  'cadastro-disciplina-espaco'],

    })
    export default class DisciplinaEspacoCadastro extends Vue {

        @Prop( ) readonly perfis!: any
        @Prop( ) readonly disciplina!: any

        public service = new DisciplinaEspacoLocavelService();
        public espacoService = new EspacoService();

        public modal = 'modal-cadastro-disciplina-espaco';
        public editando = false;
        public processando = false;
        public espacos:any  = [];

        public espacoLocavelId: any  =  null ;

        public async created(){
            await this.buscarEspacos();
        }

        get espacos_select(){
            if(this.espacos){
                return this.espacos.map((item) => { return { value:  item.id , label: item.nome } });
            }
            return null;
        }


        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE  ,  PerfilConfig.AuxSTE  ] ,  this.perfis);
        }

        public sucesso(){
            this.espacoLocavelId = null
            this.$emit("cadastro-disciplina-espaco", null);
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        public getdados(){
            const dados = {
                disciplinaId: this.disciplina.id ,
                espacoLocavelId: this.espacoLocavelId ,
            };
            return dados;
        }

        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){ return; }
            if( !this.espacoLocavelId ){
                SiteUtils.toastErro('Error! ' , 'Selecione um espaço locável.');
                return;
            }
            this.processando = true ;
            const dados = this.getdados() ;
            setTimeout(() => {
                this.service.cadastrar(  dados )
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.sucesso();
                    this.processando = false ;
                    this.editando = false ;
                })
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });
            }, 100);
        }


        public async  buscarEspacos(){
            await this.espacoService.getAll(`take=1000`)
            .then(response => {
                this.espacos =  response.data ;
            })
        }

    }

